import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {COOKIE_CONSENT, getCookie} from '../config/cookies.config';

/**
 * Blokuje dostęp do tras wymagających zgody cookie.
 * Brak cookie → redirect na /cookie-consent
 */
export const cookieConsentGuard: CanActivateFn = () => {
  const router = inject(Router);

  if (!getCookie(COOKIE_CONSENT)) {
    return router.createUrlTree(['/cookie-consent']);
  }

  return true;
};
